{
  "title": "Zahlung",
  "subtitle": "Schließen Sie die Zahlung für Ihre Markenregistrierung ab",
  "summary": {
    "title": "Bestellübersicht",
    "countries": "Ausgewählte Länder",
    "classes": "Nizza-Klassen",
    "subtotal": "Zwischensumme",
    "governmentFees": "Behördengebühren",
    "serviceFee": "Servicegebühr",
    "total": "Gesamt",
    "taxNote": "Preise inkl. anfallender Steuern"
  },
  "methods": {
    "title": "Zahlungsmethode",
    "card": "Kredit-/Debitkarte",
    "cardNumber": "Kartennummer",
    "expiry": "Ablaufdatum",
    "cvc": "CVC",
    "nameOnCard": "Name auf der Karte",
    "secure": "Sichere Zahlung",
    "stripeTitle": "Sichere Zahlung mit Stripe",
    "stripeDesc": "Ihre Zahlung wird sicher über Stripe verarbeitet. Wir speichern niemals Ihre Kreditkarteninformationen.",
    "ssl": "256-Bit SSL-Verschlüsselung",
    "pci": "PCI DSS konform",
    "cards": "Akzeptiert alle gängigen Kreditkarten"
  },
  "status": {
    "processing": "Zahlung wird verarbeitet...",
    "success": "Zahlung erfolgreich!",
    "failed": "Zahlung fehlgeschlagen",
    "tryAgain": "Bitte versuchen Sie es erneut oder verwenden Sie eine andere Zahlungsmethode.",
    "pending": "Zahlung ausstehend",
    "refunded": "Erstattet"
  },
  "confirmation": {
    "title": "Zahlung bestätigt",
    "thankYou": "Vielen Dank für Ihre Zahlung!",
    "receiptSent": "Eine Quittung wurde an {{email}} gesendet",
    "nextSteps": "Nächste Schritte",
    "applicationSubmitted": "Ihre Markenanmeldung wurde zur Bearbeitung eingereicht.",
    "viewStatus": "Anmeldungsstatus anzeigen",
    "downloadReceipt": "Quittung herunterladen"
  },
  "buttons": {
    "pay": "{{amount}} bezahlen",
    "payNow": "Jetzt bezahlen",
    "reviewOrder": "Bestellung überprüfen",
    "proceedToPayment": "Zur Zahlung",
    "payAmount": "${{amount}} bezahlen - Zur sicheren Kasse",
    "agreeTerms": "Ich stimme den",
    "terms": "Nutzungsbedingungen",
    "and": "und der",
    "privacy": "Datenschutzrichtlinie"
  }
}
